module.exports = __webpack_public_path__ + "img/Denmark.a99e44fb.png";